import { render } from "./checkDescrip1226.vue?vue&type=template&id=1a2ab67f&scoped=true&ts=true"
import script from "./checkDescrip1226.vue?vue&type=script&lang=ts"
export * from "./checkDescrip1226.vue?vue&type=script&lang=ts"

import "./checkDescrip1226.vue?vue&type=style&index=0&id=1a2ab67f&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2ab67f"]])

export default __exports__